module.exports = __webpack_public_path__ + "static/media/21ECLAC35.1244a875.jpg";